import {
  FilterFieldDataType,
  FilterFieldEditorType,
} from '@warebee/shared/common';
import { ItemDataColumn } from '@warebee/shared/dataset-queries';
import { TFunction } from 'i18next';
import { FilterFieldConfig } from '../../common/types';
import { Formatter } from '../../common/useFormatter';
import i18n from '../../i18n';

export function getItemSetFilterConfigDefault(
  t: TFunction<'app'> = i18n.t,
  formatter?: Formatter,
): FilterFieldConfig<ItemDataColumn>[] {
  return [
    {
      type: 'consignee',
      title: t(`Client (Consignee)`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'sku',
      title: t(`Item`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'skuGroup',
      title: t(`Item Group`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'subGroup',
      title: t(`Item Sub Group`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'transportClass',
      title: t(`Transport Class`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'stockCategory',
      title: t(`Stock Category`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'storageClass',
      title: t(`Storage Class`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'pollutionClass',
      title: t(`Pollution Class`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'netWeight',
      title: t(`Weight`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      format: formatter?.formatWeight,
    },
    {
      type: 'length',
      title: t(`Length`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      format: formatter?.formatDistance,
    },
    {
      type: 'width',
      title: t(`Width`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      format: formatter?.formatDistance,
    },
    {
      type: 'height',
      title: t(`Height`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      format: formatter?.formatDistance,
    },
    {
      type: 'volume',
      title: t(`Volume`, { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
      dataType: FilterFieldDataType.NumberRange,
      format: formatter?.formatVolume,
    },
  ];
}
